<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Selling Price List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="priceLists"
              :search="search"
            >
              <!-- action template -->
              <template v-slot:item.viewAction="{ item }">
                <v-btn color="editIcon" text :to="`/list/report/sp/${item.id}`" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Price List", value: "Name" },
      { text: "Manage", value: "viewAction" },
    ],
    priceLists: [],
  }),
  methods: {
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>